import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createLogger } from 'vue-logger-plugin'
import VueDOMPurifyHTML from 'vue-dompurify-html'

import App from './App.vue'
import router from './router'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/styles/main.scss'

const isProduction = import.meta.env.VITE_APP_MODE === 'production'

const app = createApp(App)

const options = {
  enabled: true,
  level: isProduction ? 'error' : 'debug'
}

app
  .use(createPinia())
  .use(router)
  .use(Antd)
  .use(VueDOMPurifyHTML)
  .use(createLogger(), options)
  .mount('#app')
